export default function SectionNav() {
  return (
    <nav className="qnav">
      <div className="wrap">
        <a href="#s1">
          <b>01</b>
          포탈 구성
        </a>
        <a href="#s2">
          <b>02</b>
          지식 파이프라인
        </a>
        <a href="#s3">
          <b>03</b>
          워크플로우 빌더
        </a>
        <a href="#s4">
          <b>04</b>
          RAG 챗봇
        </a>
        <a href="#s5">
          <b>05</b>
          라이브러리
        </a>
        <a href="#s6">
          <b>06</b>
          관리 기능
        </a>
      </div>
    </nav>
  );
}
